import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { ReactNode, useState } from 'react';

type CollapsibleSectionProps = {
  title: string;
  children: ReactNode;
  defaultExpanded?: boolean;
  actions?: ReactNode;
};

export const CollapsibleSection = ({
  title,
  children,
  defaultExpanded = false,
  actions,
}: CollapsibleSectionProps) => {
  const [expanded, setExpanded] = useState(defaultExpanded);

  return (
    <Accordion
      expanded={expanded}
      onChange={(_, isExpanded) => setExpanded(isExpanded)}
      sx={{
        '&:before': { display: 'none' },
        boxShadow: 'none',
        width: '100%',
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{
          flexDirection: 'row-reverse',
          justifyContent: 'flex-end',
          '& .MuiAccordionSummary-expandIconWrapper': {
            transform: expanded ? 'rotate(0deg)' : 'rotate(-90deg)',
          },
          '& .MuiAccordionSummary-content': {
            margin: '12px 0',
            alignItems: 'center',
            justifyContent: 'flex-start',
            flexGrow: 0,
            minWidth: 0,
            display: 'flex',
            gap: '0.5rem',
            '&.Mui-expanded': {
              margin: '12px 0',
            },
          },
        }}
      >
        <Typography variant="h6" sx={{ marginLeft: '1em' }}>
          {title}
        </Typography>
        {actions}
      </AccordionSummary>
      <AccordionDetails
        sx={{
          backgroundColor: 'rgba(255, 255, 255, 0.05)',
          padding: '1rem',
        }}
      >
        {children}
      </AccordionDetails>
    </Accordion>
  );
};
